NtechApp.Overlay = function($wrapper, css) {
    this._sizesResolver = new NtechApp.SizesResolver();

    this._$overlay = null;
    this._rmTimeout = null;

    this._$wrapper = $wrapper || false;
    this._css = css || false;

    this._create();
};

NtechApp.proto(NtechApp.Overlay, {
    getView: function() {
        return this._$overlay;
    },

    updateCss: function(css) {
        this._$overlay.css(css);
    },

    _create: function() {
        var $wrapper = this._$wrapper || $("body");

        this._$overlay = $("<div class='ntechapp-overlay'></div>");
        this._$overlay.appendTo($wrapper);

        if(this._css)
            this._$overlay.css(this._css);

        // Apply opacity: 0 per item right after append
        this._sizesResolver.getComputedCss(this._$overlay).opacity;
        //this._$overlay.addClass("visible");
    },

    on: function() {
        // if(this._$overlay != null) {
        //     clearTimeout(this._rmTimeout);
        //     return;
        // }
        clearTimeout(this._rmTimeout);
        this._$overlay.css("display", "block");

        // var $wrapper = this._$wrapper || $("body");

        // this._$overlay = $("<div class='ntechapp-overlay'></div>");
        // this._$overlay.appendTo($wrapper);

        // if(this._css)
        //     this._$overlay.css(this._css);

        // Apply opacity: 0 per item right after append
        this._sizesResolver.getComputedCss(this._$overlay).opacity;
        this._$overlay.addClass("visible");
    },

    off: function(timeout) {
        var me = this;
        var timeout = timeout || 500;
        //if(this._$overlay == null) return;

        this._$overlay.removeClass("visible");
        // this._rmTimeout = setTimeout(function() {
        //     if(me._$overlay == null) return;

        //     me._$overlay.remove();
        //     me._$overlay = null;
        // }, 500);
        this._rmTimeout = setTimeout(function() {
            me._$overlay.css("display", "none");
        }, timeout);
    },

    destroy: function() {
        this._$overlay.remove();
    }
});